import React, { useEffect, useState } from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { api } from "../../lib/api";

const FALLBACK = {
    label: "// Honest answers",
    title_prefix: "Questions we get",
    title_highlight: "most weeks.",
    items: [
        { q: "Do I need to be on camera?", a: "Nope. We work with plenty of business owners who never appear on the feed. If you DO want to be, we'll coach you gently." },
        { q: "What if I'm too small to need this?", a: "If you have a business and you make money from it, you're not too small. Our Start plan is designed exactly for one-person shops." },
        { q: "Will you lock me into a long contract?", a: "No. 60-day minimum, then month-to-month. Cancel any time after that with one email." },
    ],
};

export default function FAQ() {
    const [content, setContent] = useState(FALLBACK);
    useEffect(() => {
        api.get("/site-content/faq")
            .then((r) => setContent({ ...FALLBACK, ...r.data.data }))
            .catch(() => {});
    }, []);

    const faqs = content.items || [];

    return (
        <section
            id="faq"
            className="relative border-b border-hairline bg-sage py-24 lg:py-36"
            data-testid="faq-section"
        >
            <div className="mx-auto max-w-[1100px] px-5 lg:px-10">
                <div className="mb-14 max-w-3xl lg:mb-20">
                    <div className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-coral">
                        {content.label}
                    </div>
                    <h2 className="font-display text-5xl font-black leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl">
                        {content.title_prefix}{" "}
                        <span className="font-serif italic font-normal text-coral">
                            {content.title_highlight}
                        </span>
                    </h2>
                </div>

                <Accordion
                    type="single"
                    collapsible
                    className="border-2 border-ink bg-oat"
                    data-testid="faq-accordion"
                >
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`q-${i}`}
                            className={`border-ink/15 px-5 lg:px-8 ${i === faqs.length - 1 ? "border-b-0" : "border-b"}`}
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="py-6 text-left font-display text-base font-bold uppercase tracking-tight text-ink hover:text-coral hover:no-underline lg:text-lg">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="pb-6 text-sm leading-relaxed text-ink/70 lg:text-base">
                                <span dangerouslySetInnerHTML={{ __html: f.a }} />
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>

                <div className="mt-10 flex items-center gap-4 border-t border-ink/15 pt-8">
                    <p className="text-sm text-ink/70 lg:text-base">
                        Still got a question? We answer everything within 24 hours.
                    </p>
                    <a
                        href="#contact"
                        className="inline-flex items-center gap-2 border-b-2 border-coral pb-1 font-display text-sm font-bold uppercase tracking-wider text-coral hover:text-ink hover:border-ink"
                        data-testid="faq-cta"
                    >
                        Ask us →
                    </a>
                </div>
            </div>
        </section>
    );
}
